/* eslint-disable */

import React, { useState } from "react";
import { IconGridDots } from "@tabler/icons-react";
import { Box, Typography, Drawer, IconButton } from "@mui/material";
import Navigation from "./Navigation";

function MobileRightSidebar() {
  const [showDrawer, setShowDrawer] = useState(false);
  const [open, setOpen] = React.useState(true);
  const handleClick = () => {
    setOpen(!open);
  };

  const cartContent = (
    <Box>
      <Navigation setShowDrawer={setShowDrawer} />
    </Box>
  );

  return (
    <Box>
      <IconButton
        size="large"
        color="inherit"
        onClick={() => setShowDrawer(true)}
        sx={{
          ...(showDrawer && {
            color: "primary.main",
          }),
        }}
      >
        <IconGridDots size="21" stroke="1.5" />
      </IconButton>
      {/* ------------------------------------------- */}
      {/* Cart Sidebar */}
      {/* ------------------------------------------- */}
      <Drawer anchor="right" open={showDrawer} onClose={() => setShowDrawer(false)} PaperProps={{ sx: { width: "300px" } }}>
        <Box p={3} pb={0}>
          <Typography variant="h5" fontWeight={600}>
            Navigation
          </Typography>
        </Box>
        {cartContent}
      </Drawer>
    </Box>
  );
}

export default MobileRightSidebar;
